module.exports = __webpack_public_path__ + "media/images/icon-twitter@3x-895c38a0b57af4f093800a9a1b994b1c.png";